import React from "react";
import {
  navigateWithinPortal,
  withPortalContext,
} from "../routing/portalRoutes";

interface PortalLinkProps
  extends Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, "href"> {
  path: string;
  clinicianCode: string;
}

export function PortalLink({
  path,
  clinicianCode: _clinicianCode,
  onClick,
  children,
  ...props
}: PortalLinkProps) {
  const href = withPortalContext(path);

  return (
    <a
      {...props}
      href={href}
      onClick={(event) => {
        onClick?.(event);
        if (
          event.defaultPrevented ||
          event.button !== 0 ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey ||
          props.target === "_blank"
        ) {
          return;
        }
        event.preventDefault();
        navigateWithinPortal(href);
      }}
    >
      {children}
    </a>
  );
}
